import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MedIconCheckModule } from "@mk/med-icons";

import { MedMultiselectItemComponent } from "./med-multiselect-item.component";

@NgModule({
  declarations: [
    MedMultiselectItemComponent,
  ],
  imports: [
    CommonModule,
    MedIconCheckModule,
  ],
  exports: [
    MedMultiselectItemComponent,
  ],
})
export class MedMultiselectItemModule { }
